
import { useState } from "react";
import { VerificationEmailDisplay } from "./form/VerificationEmailDisplay";
import { VerificationCodeField } from "./form/VerificationCodeField";
import { VerificationActions } from "./form/VerificationActions";

interface VerificationFormProps {
  pendingVerificationEmail: string;
  isLoading: boolean;
  onVerify: (code: string) => Promise<any>;
  onResendCode: () => Promise<any>;
  onBackToLogin: () => void;
}

export const VerificationForm = ({
  pendingVerificationEmail,
  isLoading,
  onVerify,
  onResendCode,
  onBackToLogin,
}: VerificationFormProps) => {
  const [verificationCode, setVerificationCode] = useState("");

  const handleSubmit = async (e?: React.FormEvent) => {
    if (e) {
      e.preventDefault();
    }
    await onVerify(verificationCode);
  };

  const isValidCode = verificationCode.length === 6;

  return (
    <form onSubmit={handleSubmit} className="space-y-5">
      <VerificationEmailDisplay email={pendingVerificationEmail} />
      
      <VerificationCodeField
        value={verificationCode}
        onChange={(e) => setVerificationCode(e.target.value)}
        isDisabled={isLoading}
      />
      
      <VerificationActions
        isLoading={isLoading}
        isValidCode={isValidCode}
        onVerify={handleSubmit}
        onResendCode={onResendCode}
        onBackToLogin={onBackToLogin}
      />
    </form>
  );
};
